import { defineStore } from 'pinia'

export const EDITOR_THEMES = [
  { id: 'one_dark', label: 'One Dark', dark: true },
  { id: 'monokai', label: 'Monokai', dark: true },
  { id: 'dracula', label: 'Dracula', dark: true },
  { id: 'tomorrow_night', label: 'Tomorrow Night', dark: true },
  { id: 'nord_dark', label: 'Nord Dark', dark: true },
  { id: 'github_dark', label: 'GitHub Dark', dark: true },
  { id: 'cobalt', label: 'Cobalt', dark: true },
  { id: 'chrome', label: 'Chrome', dark: false },
  { id: 'github', label: 'GitHub', dark: false },
  { id: 'solarized_light', label: 'Solarized Light', dark: false },
  { id: 'xcode', label: 'Xcode', dark: false },
  { id: 'dawn', label: 'Dawn', dark: false },
]

export const useEditorStore = defineStore('editor', {
  state: () => ({
    theme: localStorage.getItem('ace-theme') || 'one_dark',
  }),
  getters: {
    availableThemes: () => EDITOR_THEMES,
    darkThemes: () => EDITOR_THEMES.filter(t => t.dark),
    lightThemes: () => EDITOR_THEMES.filter(t => !t.dark),
  },
  actions: {
    setTheme(theme) {
      this.theme = theme
      localStorage.setItem('ace-theme', theme)
    },
  },
})
